import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import ListItemText from '@material-ui/core/ListItemText'
import ListItem from '@material-ui/core/ListItem'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
// import { TransitionProps } from '@material-ui/core/transitions';
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Autocomplete from '@material-ui/lab/Autocomplete'

import {
  loadProgrammesData,
  updateCsvAction,
  loadRolesData,
  updateSetupProgress,
  updateSummeryUserEmailList,
  loadSectionData,
  updateSectionUserData,
  clearSummeryCourses
} from '../../actions'

import { connect } from 'react-redux'
import TextField from '@material-ui/core/TextField'

import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import BrowserStore from 'store'

import LinearProgress from '@material-ui/core/LinearProgress'

import { updateSectionSISID } from '../../services/saga'
import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative'
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1
    },

    root: {
      width: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    }
  })
)

const Transition = React.forwardRef(function Transition(
  props: { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

function FullScreenDialog(props) {
  const classes = useStyles()

  const {
    fullPageModel,
    setFullPageModel,
    selectedCourse,
    rolesData,
    csvActionType,
    loadRolesData,
    loadSectionData,
    courseSectionData,
    courseSectionUserData,
    updateSectionUserData,
    selectedCoursesList,
    clearSummeryCourses
  } = props

  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')

  let roles = [[{ id: 0, label: 'Loading..' }]]

  let inputValueRole = ''

  let includeRoles = []

  const [expanded, setExpanded] = React.useState(false)

  const [courseSection, setCourseSection] = useState([])

  const [groupDetails, setGroupDetails] = useState([])

  const [optionRoles, setOptionRoles] = useState([])

  const [isLoading, setIsLoading] = useState(true)

  const [checkSectionSIS, setCheckSectionSIS] = useState(false)

  const [sectionSISUpdated, SetSectionSISUpdated] = useState(false)

  const browserData = BrowserStore.get('inseadCanvasAdmin')

  // const   radioDefaultValue = csvActionType;

  useEffect(() => {
    loadRolesData()
  }, [])

  useEffect(() => {
    let inseadCanvasAdmin = BrowserStore.get('inseadCanvasAdmin')
    let includeRoles = []

    if (inseadCanvasAdmin.sub_account.perm === 'CUSTOM') {
      includeRoles = inseadCanvasAdmin.sub_account.section_roles.split(',')
    } else {
      includeRoles = process.env.REACT_APP_ENABLE_ROLES.split(',')
    }

    let roles = []

    roles = rolesData.filter((rows) =>
      includeRoles.includes(rows.id.toString())
    )

    let kkroles = roles.map((option) => {
      const firstLetter = option.label[0].toUpperCase()

      return {
        firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
        ...option
      }
    })

    setOptionRoles(kkroles)
  }, [rolesData])

  useEffect(() => {
    if (selectedCourse.name) {
      setTitle(`${selectedCourse.name}`)
      setSubTitle(
        `SIS: ${selectedCourse.sis_course_id} - Term: ${selectedCourse.term.name}`
      )

      let userTextData = courseSectionUserData.data.filter(
        (data, i) => data[selectedCourse.id]
      )

      if (userTextData.length !== 0) {
        setGroupDetails(userTextData)
      }

      let sectionDataLoaded = courseSectionData.data.filter(
        (data, i) => data[selectedCourse.id]
      )

      if (sectionDataLoaded.length === 0) {
        loadSectionData(selectedCourse.id)
        setCheckSectionSIS(true)
      } else {
        setCourseSection(sectionDataLoaded[0][selectedCourse.id])
        setCheckSectionSIS(true)
      }
    }
  }, [selectedCourse, courseSectionData])

  const generateSectionID = (sis_course_id, name, sis_section_id) => {
    if (sis_section_id !== null) {
      return sis_section_id
    }

    let str = name.toUpperCase()
    str = str.replace(/[^a-zA-Z0-9]/g, '')

    return `${sis_course_id}-${str}`
  }

  const updatePromise = (id, payload) => {
    return new Promise((resolve, reject) => {
      updateSectionSISID(id, payload).then((data) => {
        resolve(true)
      })
    })
  }

  useEffect(() => {
    const updateSIS = (courseSectionData, checkSectionSIS) => {
      let courseSections = courseSectionData.data.filter(
        (data, i) => data[selectedCourse.id]
      )

      let updatingSIS = false

      const promises = []

      if (checkSectionSIS && courseSections.length !== 0) {
        courseSections.map(async (item) => {
          item[selectedCourse.id].map(async (child) => {
            if (child.sis_section_id === null || child.sis_section_id === '') {
              let str = child.name
              str = str.replace(/[^a-zA-Z0-9]/g, '')

              let payload = {
                course_section: {
                  sis_section_id: generateSectionID(
                    child.sis_course_id,
                    child.name,
                    child.sis_section_id
                  )
                },
                enable_sis_reactivation: true
              }
              promises.push(updatePromise(child.id, payload))
            }
          })

          updatingSIS = true
        })

        Promise.all(promises).then((response) => {
          setCheckSectionSIS(false)
          setIsLoading(false)
        })
      }
    }

    updateSIS(courseSectionData, checkSectionSIS)
  }, [checkSectionSIS, courseSectionData])
  //

  useEffect(() => {
    if (courseSection.length !== 0 && groupDetails.length === 0) {
      let newObject = {}

      newObject[selectedCourse.id] = []

      courseSection.map((item) => {
        newObject[selectedCourse.id][item.id] = {
          text: '',
          actionType: '',
          role: ''
        }
      })

      setGroupDetails([newObject])
    }
  }, [courseSection])

  useEffect(() => {
    loadRolesData()
  }, [])

  const handleClickOpen = () => {}

  useEffect(() => {}, [selectedCoursesList])

  const handleClose = () => {
    setFullPageModel(false)
    setCourseSection([])
    setGroupDetails([])

    let updatedList = selectedCoursesList.filter(
      (d) => d.id != selectedCourse.id
    )

    clearSummeryCourses(updatedList)
  }

  const handleSave = () => {
    updateSectionUserData(groupDetails[0], selectedCourse.id)

    let errors = []
    let noChanges = []

    courseSection.map((item) => {
      let sectionData = groupDetails[0][selectedCourse.id][item.id]

      if (sectionData.text !== '') {
        if (
          sectionData.actionType === '' ||
          sectionData.role === '' ||
          sectionData.role === null
        ) {
          errors.push(
            'Secion Error: ' +
              sectionData.sec +
              ' :: Select Role and Action type'
          )
        }
      }

      if (sectionData.text === '') {
        noChanges.push(sectionData.sec)
      }
    })

    if (noChanges.length === courseSection.length) {
      let updatedList = selectedCoursesList.filter(
        (d) => d.id != selectedCourse.id
      )
      clearSummeryCourses(updatedList)
    }

    if (errors.length != 0) {
      alert(errors)
    } else {
      setFullPageModel(false)
      setCourseSection([])
      setGroupDetails([])
    }
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const setRoleClick = (
    event,
    parent,
    index,
    sectionName,
    sis_course_id,
    sis_section_id
  ) => {
    let newArr = groupDetails[0] // copying the old datas array
    let item = {}
    newArr[parent][index] = {
      ...item,
      role: event,
      text: newArr[parent][index].text,
      sec: sectionName,
      actionType: newArr[parent][index].actionType,
      sis_course_id: sis_course_id,
      sis_section_id: sis_section_id
    }
    setGroupDetails([newArr])
  }

  const handleTextChange = (
    event,
    parent,
    index,
    sectionName,
    sis_course_id,
    sis_section_id
  ) => {
    let newArr = groupDetails[0] // copying the old datas array
    let item = {}
    newArr[parent][index] = {
      ...item,
      role: newArr[parent][index].role,
      text: event.target.value,
      sec: sectionName,
      actionType: newArr[parent][index].actionType,
      sis_course_id: sis_course_id,
      sis_section_id: sis_section_id
    }
    setGroupDetails([newArr])
  }

  const handleRadioChange = (
    event,
    parent,
    index,
    sectionName,
    sis_course_id,
    sis_section_id
  ) => {
    let value = event.target.value

    let newArr = groupDetails[0] // copying the old datas array
    let item = {}
    newArr[parent][index] = {
      ...item,
      role: newArr[parent][index].role,
      text: newArr[parent][index].text,
      sec: sectionName,
      actionType: value,
      sis_course_id: sis_course_id,
      sis_section_id: sis_section_id
    }
    setGroupDetails([newArr])
  }

  roles = [] //roles.filter(rows => includeRoles.includes(rows.id.toString()));

  // const optionsRoles = roles.map((option) => {
  //   const firstLetter =  option.label[0].toUpperCase();

  //   return {
  //     firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
  //     ...option,
  //   };
  // });

  const optionsRoles = []

  return (
    <div>
      <Dialog
        key='ddd'
        fullScreen
        open={fullPageModel}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClose}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              {title}
            </Typography>

            <Typography variant='span' className={classes.title}>
              {subTitle}
            </Typography>
            <Button autoFocus color='inherit' onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>

        <div className={classes.root}>
          <br /> <br />
          {isLoading === true || courseSection.length === 0 ? (
            <LinearProgress />
          ) : null}
          {courseSection.map((item) => (
            <Accordion
              key={`panel1bh-${item.id}`}
              expanded={expanded === 'panel' + item.id}
              onChange={handleChange('panel' + item.id)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1bh-content'
                key={`panel1bh-header-${item.id}`}
              >
                <Typography className={classes.heading}>SECTION</Typography>
                <Typography className={classes.secondaryHeading}>
                  {item.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {groupDetails.length === 0 ? (
                  ' loading'
                ) : (
                  <Grid container spacing={1}>
                    <Grid item md={12}>
                      {groupDetails[0][item.course_id][item.id].text !== '' &&
                      (groupDetails[0][item.course_id][item.id].role === '' ||
                        groupDetails[0][item.course_id][item.id].role ===
                          null ||
                        groupDetails[0][item.course_id][item.id].actionType ===
                          '') ? (
                        <div>
                          {' '}
                          <Alert severity='warning'>
                            Please Select a Role and Action Type
                          </Alert>{' '}
                          <br />
                        </div>
                      ) : null}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        id='combo-box-3'
                        noOptionsText='Loading..'
                        options={optionRoles.sort(
                          (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                        )}
                        getOptionLabel={(option) => option.label}
                        style={{ width: 300 }}
                        onChange={(event, newValue) => {
                          setRoleClick(
                            newValue,
                            item.course_id,
                            item.id,
                            item.name,
                            item.sis_course_id,
                            generateSectionID(
                              item.sis_course_id,
                              item.name,
                              item.sis_section_id
                            )
                          )
                        }}
                        defaultValue={
                          groupDetails[0][item.course_id][item.id].role
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label='Roles'
                            variant='outlined'
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormLabel component='legend'>Action</FormLabel>
                      <RadioGroup
                        row
                        aria-label='action'
                        name='action'
                        value={
                          groupDetails[0][item.course_id][item.id].actionType
                        }
                        onChange={(event) => {
                          handleRadioChange(
                            event,
                            item.course_id,
                            item.id,
                            item.name,
                            item.sis_course_id,
                            generateSectionID(
                              item.sis_course_id,
                              item.name,
                              item.sis_section_id
                            )
                          )
                        }}
                      >
                        <FormControlLabel
                          value='active'
                          control={<Radio />}
                          label='Add'
                        />
                        <FormControlLabel
                          value='deleted'
                          control={<Radio />}
                          label='Remove'
                        />
                      </RadioGroup>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <br />

                      <Alert severity='info'>
                        <Typography variant='caption' display='block'>
                          <strong> Use Only PeopleSoft IDs. </strong>
                        </Typography>

                        <Typography variant='caption' display='block'>
                          <strong>
                            When adding multiple users, use a comma to separate
                            users.
                          </strong>
                        </Typography>
                      </Alert>

                      <br />

                      <TextField
                        helperText="Only PeopleSoft ID's allowed."
                        key={`panel1bh-textbox-${item.id}`}
                        fullWidth
                        label={`Section - ` + item.name}
                        multiline
                        rows='12'
                        variant='outlined'
                        value={groupDetails[0][item.course_id][item.id].text}
                        onChange={(event) => {
                          handleTextChange(
                            event,
                            item.course_id,
                            item.id,
                            item.name,
                            item.sis_course_id,
                            generateSectionID(
                              item.sis_course_id,
                              item.name,
                              item.sis_section_id
                            )
                          )
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </Dialog>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    courseSectionData: state.CourseLevelAdmin.courseSection,
    courseSectionUserData: state.CourseLevelAdmin.courseSectionUserData,
    rolesData: state.CourseLevelAdmin.roles.data,
    csvActionType: state.CourseLevelAdmin.csvActionType,

    selectedCoursesList: state.CourseLevelAdmin.summery.courses
  }
}

export default connect(mapStateToProps, {
  clearSummeryCourses,
  loadProgrammesData,
  loadRolesData,
  updateCsvAction,
  updateSectionUserData,
  loadSectionData,
  updateSetupProgress,
  updateSummeryUserEmailList
})(FullScreenDialog)
